import React from 'react';
import { Layers } from 'lucide-react';
import { useScopeControlCounts } from '../../../hooks/analytics/useScopeReports.ts';
import { StatCard, WidgetCard } from '../controller/shared.tsx';

/**
 * `scope_control_counts` — total controls in scope, key vs. non-key split,
 * and a period-over-period delta. Backed by `GET /api/analytics/scope/control-counts`.
 */
export const ScopeControlCountsCard: React.FC = () => {
  const { data, isLoading, isError, error, dataUpdatedAt, isFetching, refetch } = useScopeControlCounts();

  return (
    <WidgetCard
      title="Control Counts by Scope"
      description="Controls currently in scope, key vs. non-key"
      loading={isLoading}
      error={isError ? error : null}
      errorMessage={error?.message ?? 'Failed to load control counts.'}
      isEmpty={!isLoading && !isError && !data}
      emptyMessage="No controls in scope yet."
      updatedAt={dataUpdatedAt}
      onRefresh={refetch}
      isFetching={isFetching}
    >
      <div className="analytics-kpi-grid gap-3">
        <StatCard
          title="Total In Scope"
          value={data?.total ?? 0}
          icon={<Layers className="h-5 w-5" />}
          color="bg-purple-100 text-purple-600"
          delta={data?.delta ?? undefined}
          deltaSuffix=""
          deltaDigits={0}
        />
        <StatCard title="Key Controls" value={data?.key_count ?? 0} color="bg-blue-100 text-blue-600" />
        <StatCard title="Non-Key Controls" value={data?.non_key_count ?? 0} color="bg-slate-100 text-slate-600" />
      </div>
    </WidgetCard>
  );
};

export default ScopeControlCountsCard;
